import { AtualizarClienteComponent } from './painel-administrativo/atualizar-cliente/atualizar-cliente.component';
import { UploadImageComponent } from './painel-administrativo/upload-image/upload-image.component';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './../@theme/home.component';
import { AdminComponent } from './../security/guards/auth-guard/admin/admin.component';
import { AuthGuard } from './../security/guards/auth-guard/auth.guard';
import { LogoutComponent } from './../security/guards/auth-guard/logout/logout.component';
import { GuardFabrica } from './../security/guards/guard.fabrica';
import { BiAspuioComponent } from './businness-intelligence/bi-aspuio/bi-aspuio-filtro/bi-aspuio.component';
import { BiCspuioComponent } from './businness-intelligence/bi-cspuio/bi-cspuio-filtro/bi-cspuio.component';
import { BiDashboardComponent } from './businness-intelligence/bi-dashboard/bi-dashboard.component';
import { BiPcauioComponent } from './businness-intelligence/bi-pcauio/bi-pcauio.filtro/bi-pcauio.component';
import { BiSpuieComponent } from './businness-intelligence/bi-spuie/bi-spuie-filtro/bi-spuie.component';
import { BiSpuioComponent } from './businness-intelligence/bi-spuio/bi-spuio.filtro/bi-spuio.component';
import { BiTolComponent } from './businness-intelligence/bi-tol/bi-tol.component';
import { OnePageComponent } from './businness-intelligence/one-page/one-page.component';
import { CommercialAtacadoComponent } from './commercial/commercial-atacado/commercial-atacado.component';
import { CommercialVarejoComponent } from './commercial/commercial-varejo/commercial-varejo.component';
import { ComunicadoComponent } from './comunicado/comunicado.component';
import { AmpDetalhadoComponent } from './estoque/amp-detalhado/amp-detalhado.component';
import { AmpComponent } from './estoque/amp/amp.component';
import { CurvaAbcComponent } from './estoque/curva-abc/curva-abc.component';
import { PcaDashboardComponent } from './estoque/pca-dashboard/pca-dashboard.component';
import { RelatorioKardexComponent } from './estoque/relatorio-kardex/relatorio-kardex.component';
import { NotFoundComponent } from './miscellaneous/not-found/not-found.component';
import { ResultadoPAComponent } from './P&A/pca/pa-resultado/resultado-PA.component';
import { VorComponent } from './P&A/vor/vor-lista/vor.component';
import { BonificacaoComponent } from './parametros/bonificacao/bonificacao.component';
import { BoxesComponent } from './parametros/boxes/boxes.component';
import { DealerComponent } from './parametros/dealer/dealer.component';
import { DespesaComponent } from './parametros/despesa/despesa.component';
import { EstoqueAmpComponent } from './parametros/estoque-amp/estoque-amp.component';
import { FuncaoComponent } from './parametros/funcao/funcao.component';
import { GrupoEconomicoComponent } from './parametros/grupo-economico/grupo-economico.component';
import { GrupoImportadorComponent } from './parametros/grupo-importador/grupo-importador.component';
import { ProdutividadeIndiceComponent } from './parametros/indice-produtividade/produtividade-indice.component';
import { MargemMOComponent } from './parametros/margem-mo/margem-mo.component';
import { MoedaComponent } from './parametros/moeda/moeda.component';
import { ObjetivoVendaComponent } from './parametros/objetivo-venda/objetivo-venda.component';
import { PassagensComponent } from './parametros/passagens/passagens.component';
import { PecasAtendidasComponent } from './parametros/pecas-atendidas/pecas-atendidas.component';
import { PecasSolicitadasComponent } from './parametros/pecas-solicitadas/pecas-solicitadas.component';
import { PrevisaoCompraComponent } from './parametros/previsao-compra/previsao-compra.component';
import { PrevisaoVendaComponent } from './parametros/previsao-venda/previsao-venda.component';
import { QuartilComponent } from './parametros/quartil/quartil.component';
import { RegionalComponent } from './parametros/regional/regional.component';
import { TipoDealerComponent } from './parametros/tipo-dealer/tipo-dealer.component';
import { TipoItemListaComponent } from './parametros/tipo-item/tipo-item-lista/tipo-item-lista.component';
import { CargaGWMListaComponent } from './montadora/carga-gwm-lista/carga-gwm-lista.component';
import { TipoOsComponent } from './parametros/tipo-os/tipo-os.component';
import { RelatorioAnaliseGeralComponent } from './rmpv/analises-bi/bi-relatorio-analise/bi-relatorio-analise.component';
import { AnaliseVendaBi01Component } from './rmpv/analises-bi/bi01-analise-venda/analise-venda-bi01.component';
import { AnaliseMargemBi02Component } from './rmpv/analises-bi/bi02-analise-margem/analise-margem-bi02.component';
import { AnalisePassagemBi03Component } from './rmpv/analises-bi/bi03-analise-passagem/analise-passagem-bi03.component';
import { AnaliseEstoqueBi04Component } from './rmpv/analises-bi/bi04-analise-estoque/analise-estoque-bi04.component';
import { AnaliseHoraBi05Component } from './rmpv/analises-bi/bi05-analise-hora/analise-hora-bi05.component';
import { ProdutividadeComponent } from './rmpv/produtividade/produtividade.component';
import { OsComponent } from './rmpv/rmpv-detalhado-os/os/os.component';
import { RmpvDetalhadoListaComponent } from './rmpv/rmpv-detalhado/rmpv-detalhado-lista/rmpv-detalhado-lista.component';
import { RmpvDetalheProdutivoComponent } from './rmpv/rmpv-detalhe-produtivo/rmpv-detalhe-produtivo.component';
import { RmpvOficinaMensalComponent } from './rmpv/rmpv-oficina-mensal/rmpv-oficina-mensal.component';
import { RmpvOficinaComponent } from './rmpv/rmpv-oficina/rmpv-oficina.component';
import { RmpvPassagemMensalComponent } from './rmpv/rmpv-passagem-mensal/rmpv-passagem-mensal.component';
import { RmpvPassagemComponent } from './rmpv/rmpv-passagem/rmpv-passagem.component';
import { RmpvPecaMensalComponent } from './rmpv/rmpv-peca-mensal/rmpv-peca-mensal.component';
import { RmpvPecaComponent } from './rmpv/rmpv-peca/rmpv-peca.component';
import { ServicoComponent } from './status/servico/servico.component';
import { UsuarioFabricaComponent } from './usuario-fabrica/usuario-fabrica.component';
import { ConsultaEstoqueComponent } from './relatorio-veiculos/veiculo-estoque/veiculo-estoque.component';
import { PrimengTesteListaComponent } from './painel-administrativo/primeng-teste/primeng-teste-lista/primeng-teste-lista.component';
import { RelatorioVeiculoDetalhadoComponent } from './relatorio-veiculos/relatorio-veiculo-detalhado/relatorio-veiculo-detalhado.component';
import { RelatorioVendasComponent } from './relatorio-veiculos/relatorio-vendas/relatorio-vendas.component';
import { SeminovosComponent } from './relatorio-veiculos/seminovos/seminovos.component';
import { VeiculoVendidoDetalhadoComponent } from './relatorio-veiculos/veiculo-vendido-detalhado/veiculo-vendido-detalhado.component';
import { VeiculoVendidoComponent } from './relatorio-veiculos/veiculo-vendido/veiculo-vendido.component';
import { VeiculosPedidosComponent } from './relatorio-veiculos/veiculos-pedidos/veiculos-pedidos.component';
import { VeiculosPropostasComponent } from './relatorio-veiculos/veiculos-propostas/veiculos-propostas.component';
import { IndicadorVendaVarejoComponent } from './businness-intelligence/indicador-venda-varejo/indicador-venda-varejo.component';
import { IndicadorVendaVeiculoComponent } from './businness-intelligence/indicador-venda-veiculo/indicador-venda-veiculo.component';
import { IndicadorVendaOficinaComponent } from './businness-intelligence/indicador-venda-oficina/indicador-venda-oficina.component';
import { RetencaoVeiculoComponent } from './businness-intelligence/bi-retencao-veiculo/retencao-veiculo.component';
import { RelatorioCargaGwmComponent } from './montadora/relatorio-carga-gwm/relatorio-carga-gwm.component';
import { BiRelatorioTaxaComponent } from './businness-intelligence/bi-relatorio-taxa/bi-relatorio-taxa.component';
import { RestricoesLgpdComponent } from './businness-intelligence/restricoes-lgpd/restricoes-lgpd.component';
import { AnaliseGarantiaComponent } from './businness-intelligence/analise-garantia/analise-garantia.component';
import { PartnumberNaoOriginalComponent } from './businness-intelligence/analise-part-number/partnumber-nao-original.component';
import { FluxoLeadsComponent } from './businness-intelligence/fluxo-leads/fluxo-leads.component';
import { SobreListaComponent } from './sobre/sobre-lista/sobre-lista.component';
import { UpdateBdListaComponent } from './painel-administrativo/update-bd/update-bd-lista/update-bd-lista.component';
import { AtualizacoesDisponiveisComponent } from './atualizacao/atualizacoes-disponiveis/atualizacoes-disponiveis.component';
import { MonitoramentoPrecosComponent } from './businness-intelligence/monitoramento-precos/monitoramento-precos.component';
import { MonitoramentoAcessoriosComponent } from './businness-intelligence/monitoramento-acessorios/monitoramento-acessorios.component';
import { CadastrarEmailComponent } from './parametros/cadastrar-email/cadastrar-email.component';
import { CadastrarFabricaListaComponent } from './painel-administrativo/cadastrar-fabrica/cadastrar-fabrica-lista/cadastrar-fabrica-lista.component';
import { CadastrarTipoOsListaComponent } from './painel-administrativo/cadastrar-tipo-os/cadastrar-tipo-os-lista/cadastrar-tipo-os-lista.component';
import { AtivacaoServicesListaComponent } from './painel-administrativo/ativacao-services/ativacao-services-lista/ativacao-services-lista.component';
import { ApuracaoVdmComponent } from './businness-intelligence/apuracao-vdm/apuracao-vdm.component';
import { ApuracaoVdmPecaComponent } from './businness-intelligence/apuracao-vdm-peca/apuracao-vdm-peca.component';
import { ApuracaoVdmAcessorioComponent } from './businness-intelligence/apuracao-vdm-acessorio/apuracao-vdm-acessorio.component';
import { AtivacaoMenuListaComponent } from './painel-administrativo/ativacao-menu/ativacao-menu-lista/ativacao-menu-lista.component';
import { StatusOperacaoComponent } from './painel-administrativo/status-operacao/status-operacao.component';
import { BancoDeDadosComponent } from './painel-administrativo/banco-de-dados/banco-de-dados.component';
import { MonitoramentoJobComponent } from './painel-administrativo/monitoramento-job/monitoramento-job.component';
import { GerenciarErrosComponent } from './painel-administrativo/gerenciar-erros/gerenciar-erros.component';
import { AlertaEscalonadoComponent } from './montadora/alerta-escalonado/alerta-escalonado.component';
import { DealerNovoComponent } from './parametros/dealerNovo/dealer.component';
import { VeiculosClvComponent } from './relatorio-veiculos/veiculos-clv/veiculos-clv.component';
import { PorcentualClvComponent } from './parametros/porcentual-clv/porcentual-clv.component';
import { PedidoPecasComponent } from './estoque/pedido-pecas/pedido-pecas.component';
import { VeiculosRegionaisComponent } from './relatorio-veiculos/veiculos-regionais/veiculos-regionais.component';
import { LeadsComponent } from './relatorio-veiculos/leads/leads.component';
import { VisaoLeadsComponent } from './relatorio-veiculos/visao-leads/visao-leads.component';
import { RegionalParametroComponent } from './parametros/regional-parametro/regional-parametro.component';
import { ConsultaVendaAcessoriosComponent } from './businness-intelligence/consulta-venda-acessorios/consulta-venda-acessorios.component';
import { FamiliaComponent } from './parametros/familia/familia.component';
import { VendasPendentesPecasComponent } from './P&A/vendas-pendentes-pecas/vendas-pendentes-pecas.component';
import { VeiculoVendidoGacComponent } from './relatorio-veiculos/veiculo-vendido-GAC/veiculo-vendido-GAC.component';
import { OperacoesBloqueadasComponent } from './painel-administrativo/operacoes-bloqueadas/operacoes-bloqueadas.component';
import { TipoEventoComponent } from './parametros/tipo-evento/tipo-evento.component';
import { TipoAndamentoComponent } from './parametros/tipo-andamento/tipo-andamento.component';
import { RelatorioOportunidadeComponent } from './businness-intelligence/relatorio-oportunidade/relatorio-oportunidade.component';
import { TipoParadaComponent } from './parametros/tipo-parada/tipo-parada.component';
import { ConsultaPlanoFamiliaComponent } from './businness-intelligence/consulta-plano-familia/consulta-plano-familia.component';
import { TipoInsucessosComponent } from './parametros/tipo-insucessos/tipo-insucessos.component';
import { VeiculosSemPassagensComponent } from './businness-intelligence/veiculos-sem-passagens/veiculos-sem-passagens.component';
import { RelatorioCoafComponent } from './businness-intelligence/relatorio-coaf/relatorio-coaf.component';
import { VendaAcessorioVeiculoComponent } from './businness-intelligence/venda-acessorio-veiculo/venda-acessorio-veiculo.component';
import { VeiculoFrequenteComponent } from './businness-intelligence/veiculo-frequente/veiculo-frequente.component';
import { RelatorioSpnvComponent } from './businness-intelligence/relatorio-spnv/relatorio-spnv.component';
import { RankingComprasComponent } from './businness-intelligence/ranking-compras/ranking-compras.component';
import { NbsextratorComponent } from './painel-administrativo/nbsextrator/nbsextrator.component';

export const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    canActivate: [AuthGuard],
    data: { breadcrumb: 'Home' }
  },
  {
    path: 'parametro/dealer',
    component: DealerComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'Parâmetros \/ Dealer' }
  },
  {
    path: 'parametro/dealernew',
    component: DealerNovoComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'Parâmetros \/ Dealer New' }
  },
  {
    path: 'parametro/tipo-dealer',
    component: TipoDealerComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'Parâmetros \/ Tipo Dealer' }
  },
  {
    path: 'parametro/tipo-evento',
    component: TipoEventoComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'Parâmetros \/ Tipo Evento'}
  },
  {
    path: 'parametro/tipo-andamento',
    component: TipoAndamentoComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'Parâmetros \/ Tipo Andamento'}
  },
  {
    path: 'parametro/tipo-parada',
    component: TipoParadaComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'Parâmetros \/ Tipo Parada'}
  },
  {
    path: 'parametro/tipo-insucesso',
    component: TipoInsucessosComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'Parâmetros \/ Tipo Insucesso'}
  },
  {
    path: 'parametro/previsao-venda',
    component: PrevisaoVendaComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'Parâmetros \/ Previsão de Venda' }
  },
  {
    path: 'parametro/previsao-compra',
    component: PrevisaoCompraComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'Parâmetros \/ Previsão de Compra' }
  },
  {
    path: 'parametro/tipo-item',
    component: TipoItemListaComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'Parâmetros \/ Tipo de Item' }
  },
  {
    path: 'painel_admin/cadastrar-fabrica',
    component: CadastrarFabricaListaComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'Painel Admin \/ Cadastrar Fábrica' }
  },
  {
    path: 'painel_admin/cadastrar-tipo-os',
    component: CadastrarTipoOsListaComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'Painel Admin \/ Cadastrar Tipo O.S' }
  },
  {
    path: 'painel_admin/ativacao-services',
    component: AtivacaoServicesListaComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'Painel Admin \/ Ativação de Serviços' }
  },
  {
    path: 'painel_admin/atualizar-cliente',
    component: AtualizarClienteComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'Painel Admin \/ Atualizar Serviço Cliente' }
  },
  {
    path: 'painel_admin/upload-image',
    component: UploadImageComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'Painel Admin \/ Upload Imagem' }
  },
  {
    path: 'painel_admin/update-bd',
    component: UpdateBdListaComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'Painel Admin \/ Update DB' }
  },
  {
    path: 'painel_admin/ativacao-menu',
    component: AtivacaoMenuListaComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'Painel Admin \/ Ativação de Menu' }
  },
  {
    path: 'painel_admin/banco-de-dados',
    component: BancoDeDadosComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'Painel Admin \/ Banco de Dados' }
  },
  {
    path: 'painel_admin/monitoramento-job',
    component: MonitoramentoJobComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'Painel Admin \/ Monitoramento de Job' }
  },
  {
    path: 'painel_admin/gerenciar-erros',
    component: GerenciarErrosComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'Painel Admin \/ Gerenciar Erros' }
  },
  {
    path: 'painel_admin/operacoes-bloqueadas',
    component: OperacoesBloqueadasComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'Painel Admin \/ Operações Bloqueadas' }
  },
  {
    path: 'painel_admin/nbsextrator',
    component: NbsextratorComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'Painel Admin \/ NBS Extrator' }
  },
  {
    path: 'montadora/carregar-arquivos',
    component: CargaGWMListaComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'Montadora \/ Carregar Arquivos' }
  },
  {
    path: 'montadora/relatorio-carga-montadora',
    component: RelatorioCargaGwmComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'Montadora \/ Relatório Carga Montadora' }
  },
  {
    path: 'montadora/alerta-escalonado',
    component: AlertaEscalonadoComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'Montadora \/ Alerta Escalonado' }
  },
  {
    path: 'parametro/passagens',
    component: PassagensComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'Parâmetros \/ Passagens' }
  },
  {
    path: 'parametro/despesa',
    component: DespesaComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'Parâmetros \/ Despesas' }
  },
  {
    path: 'parametro/bonificacao',
    component: BonificacaoComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'Parâmetros \/ Bonificação' }
  },
  {
    path: 'parametro/boxes',
    component: BoxesComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'Parâmetros \/ Boxes' }
  },
  {
    path: 'parametro/pecas-atendidas',
    component: PecasAtendidasComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'Parâmtros \/ Peças Atendidas' }
  },
  {
    path: 'parametro/pecas-solicitadas',
    component: PecasSolicitadasComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'Parâmetros \/ Peças Solicitadas' }
  },
  {
    path: 'parametro/margem-mo',
    component: MargemMOComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'Parâmetros \/ Margem Mão de Obra' }
  },
  {
    path: 'parametro/objetivo-venda',
    component: ObjetivoVendaComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'Parâmetros \/ Ojetivo de Venda' }
  },
  {
    path: 'parametro/grupo-importador',
    component: GrupoImportadorComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'Parâmetros \/ Grupo Importador' }
  },
  {
    path: 'parametro/grupo-economico',
    component: GrupoEconomicoComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'Parâmetros \/ Grupo Econômico' }
  },
  {
    path: 'parametro/funcao',
    component: FuncaoComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'Parâmetros \/ Função' }
  },
  {
    path: 'parametro/produtividade-indice',
    component: ProdutividadeIndiceComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'Parâmetros \/ Índice Produtividade' }
  },
  {
    path: 'parametro/estoque-amp',
    component: EstoqueAmpComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'Parâmetros \/ Estoque AMP' }
  },
  {
  path: 'bi/veiculos-sem-passagens',
  component: VeiculosSemPassagensComponent,
  canActivate: [AuthGuard, GuardFabrica],
  data: { breadcrumb: 'Busines Intelligence / Veiculos Sem Passagens'}
},
  {
    path: 'parametro/moeda',
    component: MoedaComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'Parâmetros \/ Moeda' }
  },
  {
    path: 'parametro/cadastrar-email',
    component: CadastrarEmailComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'Parâmetros \/ Autenticação' }
  },
  {
    path: 'produtividade',
    component: ProdutividadeComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'Produtividade' }
  },
  {
    path: 'produtividade/dealer/produtivo',
    component: RmpvDetalheProdutivoComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'Produtividade\/Dealer\/Produtivo' }
  },
  {
    path: 'parametro/quartil',
    component: QuartilComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'Parâmetros\/Quartil' }
  },
  {
    path: 'rmpv/oficina',
    component: RmpvOficinaComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'RMPV \/ Oficina' }
  },
  {
    path: 'rmpv/oficina/mensal',
    component: RmpvOficinaMensalComponent,
    canActivate: [AuthGuard],
    data: { breadcrumb: 'RMPV \/ Oficina \/ Mensal' }
  },
  {
    path: 'rmpv/peca',
    component: RmpvPecaComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'RMPV \/ Peças' }
  },
  {
    path: 'rmpv/peca/mensal',
    component: RmpvPecaMensalComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'RMPV \/ Peça \/ Mensal' }
  },
  {
    path: 'rmpv/passagem',
    component: RmpvPassagemComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'RMPV \/ Passagem' }
  },
  {
    path: 'rmpv/passagem/mensal',
    component: RmpvPassagemMensalComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'RMPV \/ Passagem \/ Mensal' }
  },
  {
    path: 'rmpv/detalhado',
    component: RmpvDetalhadoListaComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'RMPV \/ Detalhado' }
  },
  {
    path: 'pea/resultado',
    component: ResultadoPAComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'PCA' }
  },
  {
    path: 'pca/vendas-pendentes-pecas',
    component: VendasPendentesPecasComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'PCA \/ Vendas Pendentes Peças' }
  },
  {
    path: 'pca/vor',
    component: VorComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'PCA \/ VOR' }
  },
  {
    path: 'bi/CSPUIO',
    component: BiCspuioComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'BI \/ CSPUIO' }
  },
  {
    path: 'bi/ASPUIO',
    component: BiAspuioComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'BI \/ ASPUIO' }
  },
  {
    path: 'bi/PCAUIO',
    component: BiPcauioComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'BI \/ PCAUIO' }
  },
  {
    path: 'bi/SPUIO',
    component: BiSpuioComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'BI \/ SPUIO' }
  },
  {
    path: 'bi/SPUIE',
    component: BiSpuieComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'BI \/ SPUIE' }
  },
  {
    path: 'bi/dashboard',
    component: BiDashboardComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'BI \/ Dashboard' }
  },
    {
    path: 'bi/analise-garantia',
    component: AnaliseGarantiaComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'Parâmetros \/ Análise de Garantia' }
  },
  {
    path: 'bi/partnumbers-nao-originais',
    component: PartnumberNaoOriginalComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'BI \/ Partnumbers Não Originais' }
  },
  {
    path: 'bi/fluxo-leads',
    component: FluxoLeadsComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'Business Intelligence \/ Fluxo de Leads' }
  },
  {
  path: 'bi/one-page',
  component: OnePageComponent,
  canActivate: [AuthGuard, GuardFabrica],
  data: { breadcrumb: 'BI / One Page Volvo' }
},
  {
    path: 'bi/tol',
    component: BiTolComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'BI \/ Service Records' }
  },
  {
    path: 'bi/indicador-venda-varejo',
    component: IndicadorVendaVarejoComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'BI \/ Indicador Venda Varejo' }
  },
  {
    path: 'bi/indicador-venda-veiculo',
    component: IndicadorVendaVeiculoComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'BI \/ Indicador Venda Veiculo' }
  },
  {
    path: 'bi/indicador-venda-oficina',
    component: IndicadorVendaOficinaComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'BI \/ Indicador Venda Oficina' }
  },
  {
    path: 'bi/retencao-veiculo',
    component: RetencaoVeiculoComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'BI \/ Retenção Veículo' }
  },
  {
    path: 'bi/relatorio-taxa',
    component: BiRelatorioTaxaComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'BI \/ Relatório Taxa Serviço' }
  },
  {
    path: 'bi/restricoes-lgpd',
    component: RestricoesLgpdComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'BI \/ Restrições LGPD' }
  },
  {
    path: 'bi/monitoramento-precos',
    component: MonitoramentoPrecosComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'BI \/ Monitoramento de Preços' }
  },  
  {
    path: 'bi/monitoramento-acessorios',
    component: MonitoramentoAcessoriosComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'BI \/ Monitoramento de Acessórios' }
  },
  {
    path: 'bi/apuracao-vdm',
    component: ApuracaoVdmComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'BI \/ Apuração VDM - Peças' }
  },
  {
    path: 'bi/apuracao-vdm-peca',
    component: ApuracaoVdmPecaComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'BI \/ Apuração VDM - Peças New' }
  },
    {
    path: 'bi/relatorio-oportunidade',
    component: RelatorioOportunidadeComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'BI \/ Relatório de Oportunidade ' }
  },
  {
    path: 'bi/apuracao-vdm-acessorio',
    component: ApuracaoVdmAcessorioComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'BI \/ Apuração VDM - Acessórios' }
  },
  {
    path: 'bi/consulta-plano-familia',
    component: ConsultaPlanoFamiliaComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'BI \/ Consulta Plano Familia' }
  },
  {
    path: 'bi/relatorio-coaf',
    component: RelatorioCoafComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'BI \/ Relatório COAF' }
  },
  {
    path: 'commercial/commercial-atacado',
    component: CommercialAtacadoComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'Commercial \/ Commercial Atacado' }
  },
  {
    path: 'commercial/commercial-varejo',
    component: CommercialVarejoComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'Commercial \/ Commercial Varejo' }
  },
  {
    path: 'estoque/pca-dashboard',
    component: PcaDashboardComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'Estoque \/ PCA - Dashboard' }
  },
  {
    path: 'estoque/curva-abc',
    component: CurvaAbcComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'Estoque \/ Curva ABC' }
  },
  {
    path: 'estoque/amp',
    component: AmpComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'Estoque \/ AMP' }
  },
  {
    path: 'estoque/amp-detalhado',
    component: AmpDetalhadoComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'Estoque \/ AMP \/ Detalhado' }
  },
  {
    path: 'estoque/relatorio-kardex',
    component: RelatorioKardexComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'Estoque \/ Relatório Kardex' }
  },
  {
    path: 'estoque/pedido-pecas',
    component: PedidoPecasComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'Estoque \/ Pedido de Peças' }
  },
  {
    path: 'rmpv/analise-venda-bi01',
    component: AnaliseVendaBi01Component,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'Análise de Vendas - Bi01' }
  },
  {
    path: 'rmpv/analise-margem-bi02',
    component: AnaliseMargemBi02Component,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'Análise de Margem - Bi02' }
  },
  {
    path: 'rmpv/analise-passagem-bi03',
    component: AnalisePassagemBi03Component,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'Análise de Passagem - Bi03' }
  },
  {
    path: 'rmpv/analise-estoque-bi04',
    component: AnaliseEstoqueBi04Component,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'Análise de Estoque - Bi04' }
  },
  {
    path: 'rmpv/analise-hora-bi05',
    component: AnaliseHoraBi05Component,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'Análise de Hora - Bi05' }
  },
  {
    path: 'rmpv/relatorio-analise-geral',
    component: RelatorioAnaliseGeralComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'Relatório Análise Geral' }
  },
  {
    path: 'relatorio-vendas',
    component: RelatorioVendasComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'Relatorio Vendas' }
  },
  {
    path: 'seminovos',
    component: SeminovosComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'Seminovos' }
  },
  {
    path: 'veiculo/estoque',
    component: ConsultaEstoqueComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'Veículo \/ Estoque' }
  },
  {
    path: 'veiculo/vendido',
    component: VeiculoVendidoComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'Veículo \/ Vendido' }
  },
  {
    path: 'veiculo/vendido-gac',
    component: VeiculoVendidoGacComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'Veículo \/ Vendido GAC' }
  },
  {
    path: 'veiculo/vendido-detalhado',
    component: VeiculoVendidoDetalhadoComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'Veículo \/ Vendido' }
  },
  {
    path: 'veiculo/relatorio-regional',
    component: VeiculosRegionaisComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'Veículo \/ Regional' }
  },
  {
    path: 'veiculo/painel-leads',
    component: VisaoLeadsComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'Veículo \/ Painel de Leads' }
  },
  {
    path: 'veiculo/leads',
    component: LeadsComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'Veículo \/ Leads' }
  },
  {
    path: 'veiculo/veiculos-propostas',
    component: VeiculosPropostasComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'Veículo \/ Controle de Propostas' }
  },
  {
    path: 'veiculo/veiculos-pedidos',
    component: VeiculosPedidosComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'Veículo \/ Controle de Pedidos' }
  },
  {
    path: 'primeng-teste',
    component: PrimengTesteListaComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'primeng-teste' }
  },
  {
    path: 'relatorio-vendas/detalhado',
    component: RelatorioVeiculoDetalhadoComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'Relatório Vendas \/ Detalhado' }
  },
  {
    path: 'bi/clv',
    component: VeiculosClvComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'Business Intelligence \/ Clv - Customer Lifetime' }
  },
  {
    path: 'bi/consulta-venda-acessorios',
    component: ConsultaVendaAcessoriosComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'Business Intelligence \/ Consulta Venda Acessórios' }
  },
  {
    path: 'bi/venda-acessorio-veiculo',
    component: VendaAcessorioVeiculoComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'Business Intelligence \/ Venda Acessório Por Veículo' }
  },
  {
    path: 'bi/veiculo-frequente',
    component: VeiculoFrequenteComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'Business Intelligence \/ Veículo Frequente' }
  },
  {
    path: 'bi/relatorio-spnv',
    component: RelatorioSpnvComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'Business Intelligence \/ SPNV Comparativo' }
  },
  {
    path: 'bi/ranking-compras',
    component: RankingComprasComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'Business Intelligence \/ Ranking de Compras' }
  },
  {
    path: 'parametro/tipo-os',
    component: TipoOsComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'Parâmetros \/ Tipo O.S.' }
  },
  {
    path: 'parametro/familia',
    component: FamiliaComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'Parâmetros \/ Familia' }
  },
  {
    path: 'parametro/porcentual-clv',
    component: PorcentualClvComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'Parâmetros \/ Porcentual CLV' }
  },
  {
    path: 'parametro/regional',
    component: RegionalParametroComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'Parâmetros \/ Regional' }
  },
  {
    path: 'os/:numero',
    component: OsComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'O.S.' }
  },
  {
    path: 'regional',
    component: RegionalComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'Parâmetros \/ Regional' }
  },
  {
    path: 'usuario_fabrica',
    component: UsuarioFabricaComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'Acessos \/ Usuário' }
  },
  {
    path: 'status/servico',
    component: ServicoComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'Status \/ Serviço' }
  },
  {
    path: 'painel_admin/status-operacao',
    component: StatusOperacaoComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'Painel Admin \/ Status Operação' }
  },
  {
    path: 'comunicado',
    component: ComunicadoComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'Comunicados ' }
  },
  {
    path: 'sobre',
    component: SobreListaComponent,
    canActivate: [AuthGuard, GuardFabrica],
    data: { breadcrumb: 'Sobre' }
  },
  
  {
    path: 'admin',
    component: AdminComponent,
    data: { breadcrumb: 'Login' }
  },
  {
    path: 'login',
    component: AdminComponent,
    data: { breadcrumb: 'Admin' }
  },
  {
    path: 'logout',
    component: LogoutComponent,
    data: { breadcrumb: 'Logout' }
  },
  {
    path: 'atualizacao_portal',
    component: AtualizacoesDisponiveisComponent,
    data: { breadcrumb: 'Atualizações:' }
  },
  {
    path: 'not_found',
    component: NotFoundComponent
  },
  { path: '*path', redirectTo: 'not_found', pathMatch: 'full' }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' }),
    CommonModule
  ],
  exports: [
    RouterModule
  ],
  providers: [
    AuthGuard
  ],
  declarations: []
})
export class AppRoutingModule { }
